// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/SizePicker/style.css
// module id = 1844
// module chunks = 0